import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiFetch from "../../utlis/apiFetch";
import { forceLogout } from "../../utlis/forceLogout";

const handleAuthError = (error, rejectWithValue) => {
  if (error.message === "Your session has expired") forceLogout();
  return rejectWithValue(error.message);
};

export const fetchDashboardSummary = createAsyncThunk(
  "dashboard/fetchDashboardSummary",
  async (countries, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No authentication token found");

      const countryParams =
        countries && countries.length > 0
          ? countries
              .map((country) => `countryOfInterest=${encodeURIComponent(country)}`)
              .join("&")
          : "";

      const apiUrl = `${
        process.env.REACT_APP_API_BASE_URL
      }/api/application/leadsSummary${
        countryParams ? `?${countryParams}` : ""
      }`;

      const response = await apiFetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response._data ?? await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to fetch dashboard summary data"
        );
      }

      return {
        data: data.body,
        requestedCountries: countries || [],
      };
    } catch (err) {
      return handleAuthError(err, rejectWithValue);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboardData: null,
    isLoading: false,
    error: null,
    countries: [],
  },
  reducers: {
    clearDashboardData: (state) => {
      state.dashboardData = null;
    },
    setCountries: (state, action) => {
      state.countries = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardData = action.payload.data;

        state.countries = action.payload.requestedCountries;
      })
      .addCase(fetchDashboardSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDashboardData, setCountries } = dashboardSlice.actions;
export default dashboardSlice.reducer;
